import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const StatusAlert = ({ error, success, setError, setSuccess, duration = 5000 }) => {
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), duration);
      return () => clearTimeout(timer);
    }
  }, [error, duration, setError]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), duration);
      return () => clearTimeout(timer);
    }
  }, [success, duration, setSuccess]);

  return (
    <>
      {error && (
        <div className="alert alert-danger">
          <div dangerouslySetInnerHTML={{ __html: error }} />
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          <div dangerouslySetInnerHTML={{ __html: success }} />
        </div>
      )}
    </>
  );
};

StatusAlert.propTypes = {
  error: PropTypes.string,
  success: PropTypes.string,
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  duration: PropTypes.number
};

export default StatusAlert;